import { alpha } from '@mui/material/styles';
import type { LandingPageConfig } from '@provision/landing-page-utils';
import { cleanColor, MIN_BUTTON_CONTRAST, surfaceFor, worstContrast } from '../colors';
import type { LandingTokens, Surface } from '../layouts/types';

export interface HeaderColors {
  /** Undefined keeps the layout's own bar; only the text is overridden. */
  background?: string;
  text: string;
  mutedText: string;
  line: string;
  surface: Surface;
  /** The bar is close enough to the brand that the brand button would disappear into it. */
  brandBlends: boolean;
}

/**
 * The header bar's colours, or undefined to leave the layout's bar alone. Text follows whichever
 * of the layout's light and dark reads on the bar unless the page names its own.
 */
export function resolveHeaderColors(
  header: LandingPageConfig['settings']['header'],
  t: LandingTokens,
): HeaderColors | undefined {
  const background = cleanColor(header?.backgroundColor);
  const textOverride = cleanColor(header?.textColor);
  if (!background && !textOverride) return undefined;

  const surface = surfaceFor([background ?? t.paper], t);
  const text = textOverride ?? (surface === 'dark' ? t.onDark : t.ink);

  return {
    background,
    text,
    mutedText: alpha(text, 0.72),
    line: alpha(text, 0.12),
    surface,
    brandBlends:
      background !== undefined && worstContrast(t.brand, [background]) < MIN_BUTTON_CONTRAST,
  };
}
